import { getAccessToken } from './authUtils';

export const fetchApiPost = (url: string, params: any) => {
  return fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${getAccessToken()}`,
    },
    body: JSON.stringify(params),
  });
};
